import { AssignmentTypeEnum, CaseTypeEnum } from 'api/model';
import { useEffect } from 'react';
import { toInputDateTimeString } from 'utils/date-helpers';
import { AssignmentField } from '../DetailedCaseFormProvider/types';

export interface NewAssignmentOverrides {
  firstPossibleStartTime?: Date;
  lastPossibleEndTime?: Date;
  isUsersFirstAssignmentOfDay?: boolean;
  isUsersLastAssignmentOfDay?: boolean;
}

interface UseNewAssignmentOverridesParams {
  assignmentId: number;
  newAssignmentOverrides?: NewAssignmentOverrides;
  currentCaseType: CaseTypeEnum;
  onChange: (
    assignmentId: number,
    field: AssignmentField,
    value: string
  ) => void;
}

const useNewAssignmentOverrides = ({
  assignmentId,
  newAssignmentOverrides,
  currentCaseType,
  onChange,
}: UseNewAssignmentOverridesParams) => {
  useEffect(() => {
    if (newAssignmentOverrides && assignmentId === -1) {
      if (newAssignmentOverrides.firstPossibleStartTime !== undefined) {
        // set the estimated start time to the first possible start time
        onChange(
          assignmentId,
          AssignmentField.estimatedStartTime,
          toInputDateTimeString(newAssignmentOverrides.firstPossibleStartTime)
        );
        // set the first possible start time to enable validations
        onChange(
          assignmentId,
          AssignmentField.firstPossibleStartTime,
          toInputDateTimeString(newAssignmentOverrides.firstPossibleStartTime)
        );
      }
      if (newAssignmentOverrides.lastPossibleEndTime !== undefined) {
        // set the last possible end time to enable validations
        onChange(
          assignmentId,
          AssignmentField.lastPossibleEndTime,
          toInputDateTimeString(newAssignmentOverrides.lastPossibleEndTime)
        );
      }
      if (newAssignmentOverrides.isUsersFirstAssignmentOfDay !== undefined) {
        onChange(
          assignmentId,
          AssignmentField.isUsersFirstAssignmentOfDay,
          newAssignmentOverrides.isUsersFirstAssignmentOfDay ? 'true' : 'false'
        );
      }
      if (newAssignmentOverrides.isUsersLastAssignmentOfDay !== undefined) {
        onChange(
          assignmentId,
          AssignmentField.isUsersLastAssignmentOfDay,
          newAssignmentOverrides.isUsersLastAssignmentOfDay ? 'true' : 'false'
        );
      }
      if (currentCaseType === CaseTypeEnum.Placeholder) {
        // set the initial assignment type to car placeholder
        onChange(
          assignmentId,
          AssignmentField.assignmentTypeID,
          AssignmentTypeEnum.CarPlaceholder.toString()
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignmentId, newAssignmentOverrides]);
};

export default useNewAssignmentOverrides;
